import { IS_OPEN_MOBILE_MENU } from '../ActionTypes/ActionTypeMobileMenu';

export const setMobileMenuStyle = (value) => {
  return {
    type: IS_OPEN_MOBILE_MENU,
    payload: value
  };
};
